import { IntegrationStatus } from "types/enums";
import { z } from "zod";

export const userDataSchema = z.object({
    id: z.string(),
    email: z.string().nullable(),
    email_verified_at: z.string().nullable(),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable(),
    is_super_admin: z.boolean().optional(),
    tenants: z.array(z.any()).optional(),
    commissionGroups: z.array(z.any()).optional(),
    roles: z.array(z.any()).optional(),
});

export const formSchema = z.object({
    id: z.string().uuid().optional(),
    form_structure_id: z.string().uuid(),
    custom_flow: z.boolean(),
    debug_mode: z.boolean(),
    use_new_connection_creator: z.boolean(),
    status: z.nativeEnum(IntegrationStatus),
    name: z.string().min(1, "forms.general-validation.name_required").max(255, "forms.general-validation.name_max_255"),
    description: z.string().nullable().optional(),
    offers: z.array(z.string()).optional(),
    owner_id: z.string(),
    owner: userDataSchema.optional(),
    country_id: z.number().nullable().optional(),
    category: z.string().nullable().optional(),
    label_ids: z.array(z.string()).optional(),
});

export type InformationFormData = z.infer<typeof formSchema>;
